/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult,
  NonTaxableInstitutionDetailsViewModel,
  NotFoundErrorResult,
  Result,
  ResultOfNonTaxableInstitutionDetailsViewModel,
  ValidationErrorResult,
} from '../models';
import {
    ErrorResultFromJSON,
    ErrorResultToJSON,
    NonTaxableInstitutionDetailsViewModelFromJSON,
    NonTaxableInstitutionDetailsViewModelToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfNonTaxableInstitutionDetailsViewModelFromJSON,
    ResultOfNonTaxableInstitutionDetailsViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface NonTaxableInstitutionDetailsGetRequest {
    proposalId: number;
}

export interface NonTaxableInstitutionDetailsPostRequest {
    proposalId: number;
    nonTaxableInstitutionDetailsViewModel: NonTaxableInstitutionDetailsViewModel;
}

/**
 * 
 */
export class NonTaxableInstitutionDetailsApi extends runtime.BaseAPI {

    /**
     * Get personal details for a non-taxable institution.
     */
    async nonTaxableInstitutionDetailsGetRaw(requestParameters: NonTaxableInstitutionDetailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfNonTaxableInstitutionDetailsViewModel>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling nonTaxableInstitutionDetailsGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/personal-details/non-taxable-institution/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfNonTaxableInstitutionDetailsViewModelFromJSON(jsonValue));
    }

    /**
     * Get personal details for a non-taxable institution.
     */
    async nonTaxableInstitutionDetailsGet(requestParameters: NonTaxableInstitutionDetailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfNonTaxableInstitutionDetailsViewModel> {
        const response = await this.nonTaxableInstitutionDetailsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Posts the party\'s personal details for a non taxable institution.
     */
    async nonTaxableInstitutionDetailsPostRaw(requestParameters: NonTaxableInstitutionDetailsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling nonTaxableInstitutionDetailsPost.');
        }

        if (requestParameters.nonTaxableInstitutionDetailsViewModel === null || requestParameters.nonTaxableInstitutionDetailsViewModel === undefined) {
            throw new runtime.RequiredError('nonTaxableInstitutionDetailsViewModel','Required parameter requestParameters.nonTaxableInstitutionDetailsViewModel was null or undefined when calling nonTaxableInstitutionDetailsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/personal-details/non-taxable-institution/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NonTaxableInstitutionDetailsViewModelToJSON(requestParameters.nonTaxableInstitutionDetailsViewModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Posts the party\'s personal details for a non taxable institution.
     */
    async nonTaxableInstitutionDetailsPost(requestParameters: NonTaxableInstitutionDetailsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.nonTaxableInstitutionDetailsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
